"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _chunkE = require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  display: inline-block;\n  width: 36px;\n  height: 20px;\n\n  input {\n    display: none;\n  }\n\n  /* The slider */\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 3px;\n    left: 1px;\n    right: 1px;\n    width: 34px;\n    height: 14px;\n    border-radius: 7px;\n    background-color: ", ";\n    transition: all ", ";\n  }\n\n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: 0px;\n    bottom: -3px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    background-color: ", ";\n    transition: all ", ";\n    border-radius: 10px;\n  }\n\n  input:disabled + .slider {\n    opacity: 0.5;\n    cursor: not-allowed;\n\n    &:before {\n      box-shadow: none;\n    }\n  }\n\n  input:checked + .slider,\n  input:hover + .slider {\n    background-color: ", ";\n  }\n\n  input:checked + .slider:before,\n  input:hover + .slider:before {\n    background-color: ", ";\n  }\n\n  input:checked:hover + .slider {\n    background-color: ", ";\n  }\n\n  input:checked:hover + .slider:before {\n    background-color: ", ";\n  }\n\n  input:checked + .slider:before {\n    -webkit-transform: translateX(16px);\n    -ms-transform: translateX(16px);\n    transform: translateX(16px);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Switch = function (_Component) {
  (0, _chunkB2edacfb.f)(Switch, _Component);

  function Switch(props) {
    var _this;

    (0, _chunkB2edacfb.b)(this, Switch);
    _this = (0, _chunkB2edacfb.d)(this, (0, _chunkB2edacfb.e)(Switch).call(this, props));
    _this.onChange = _this.onChange.bind((0, _chunkB2edacfb.m)(_this));
    return _this;
  }

  (0, _chunkB2edacfb.c)(Switch, [{
    key: "onChange",
    value: function onChange() {
      var _this$props = this.props,
          checked = _this$props.checked,
          onChange = _this$props.onChange;
      onChange(!checked);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? null : _this$props2$classNam,
          disabled = _this$props2.disabled,
          name = _this$props2.name,
          checked = _this$props2.checked;
      return _react.default.createElement(StyledSwitch, {
        className: "switch ".concat(className)
      }, _react.default.createElement("input", {
        name: name,
        type: "checkbox",
        checked: checked,
        disabled: disabled,
        onChange: this.onChange
      }), _react.default.createElement("span", {
        className: "slider"
      }));
    }
  }]);
  return Switch;
}(_react.Component);

(0, _chunkB2edacfb.h)(Switch, "displayName", "Switch");

var StyledSwitch = _styledComponents.default.label.withConfig({
  displayName: "Switch__StyledSwitch",
  componentId: "sc-1exytde-0"
})(_templateObject(), function (props) {
  return (0, _chunkE.a)(0.62, props.theme["$gray-50"]);
}, function (props) {
  return props.theme["$brand-ease-out-fastest"];
}, function (props) {
  return props.theme["$gray-50"];
}, function (props) {
  return props.theme["$brand-ease-out-fastest"];
}, function (props) {
  return (0, _chunkE.a)(0.62, props.theme["$brand-info"]);
}, function (props) {
  return props.theme["$brand-info"];
}, function (props) {
  return (0, _chunkE.a)(0.62, props.theme["$brand-info-dark"]);
}, function (props) {
  return props.theme["$brand-info-dark"];
});

Switch.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Switch"
};
var _default = Switch;
exports.default = _default;